import type { ReturnListParams } from '../api/returns-api';

/** Store-scoped keys: switching stores never shares cache. */
export const returnKeys = {
  all: (storeId: string) => ['stores', storeId, 'returns'] as const,
  lists: (storeId: string) => [...returnKeys.all(storeId), 'list'] as const,
  list: (storeId: string, params: ReturnListParams) =>
    [...returnKeys.lists(storeId), params] as const,
  details: (storeId: string) => [...returnKeys.all(storeId), 'detail'] as const,
  detail: (storeId: string, id: string) => [...returnKeys.details(storeId), id] as const,
};
